<div
    *ngIf="
        storageItem &&
            storageItem.movementYears &&
            storageItem.movementYears.length > 0;
        else movementChartEmpty
    "
>
    <div class="form-group year-selector" *ngIf="storageItem">
        <label for="movement-year-selector">Select year</label>
        <select
            id="movement-year-selector"
            class="form-control"
            [formControl]="movementYearSelectorControl"
        >
            <option value="" disabled selected>Select year</option>
            <option
                value="{{ year }}"
                *ngFor="let year of storageItem.movementYears"
            >
                {{ year }}
            </option>
        </select>
    </div>

    <div class="chart-container">
        <app-line-chart
            [data]="chartJsData"
            [xLabel]="xLabel"
            [yLabel]="yLabel"
            *ngIf="movementChartShow"
        ></app-line-chart>
    </div>
</div>
<ng-template #movementChartEmpty>
    <div style="margin-left: 20px">No Movements yet.</div>
</ng-template>
